import clsx from "clsx";
import styles from "./index.module.scss";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import opendropdown from "../../../assets/images/opendropdown.svg";
import closedropdown from "../../../assets/images/closedropdown.svg";
import { getItemInLocalStorage } from "../../../services/localStorage";
import { getFilterConfig } from "../../../utils/hdbDashboardUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedKpiOption,
  setFilterOptions,
  setFilterConfig,
  resetRegistrationParams,
  setActiveTab,
  setSelectedKpiTab,
  setSelectedKpiFilter,
  resetProgramState,
} from "../../../reducers/ProgramReducer";
import { RootState } from "../../../store";
import { colorizeMahatriaInfinitheism } from "../../../common/components/ColorizeMahatriaInfinitheism";
import AIOverlay from "../../../common/components/AI-overlay";
import aiIcon from "../../../assets/images/aiIconImg.svg";

const DashboardTabs = ({ activeTab = "dashboard", onTabChange, tabs }) => {
  const location = useLocation();
  const programTitle = useSelector(
    (state: RootState) => state.ProgramReducer.programName,
  );
  // const programTitle = location.state?.programTitle;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { programId } = useParams<{ programId: string }>();
  const dispatch = useDispatch();
  const selectedOption = useSelector(
    (state: RootState) => state.ProgramReducer.selectedKpiOption,
  );
  const filterOptions = useSelector(
    (state: RootState) => state.ProgramReducer.filterOptions,
  );
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  useEffect(() => {
    const fetchFilteringData = async () => {
      const filterResponse = getItemInLocalStorage("filterConfig");
      const storedProgramId = getItemInLocalStorage("programId");
      const params = new URLSearchParams(location.search);
      const parentFilterParam = params.get("parentFilter");

      let options = [];
      if (filterResponse && storedProgramId && storedProgramId === programId) {
        const parentOptions = filterResponse?.data?.parentOptions || [];
        options = parentOptions.map((option) => ({
          label: option.label,
          value: option.value,
          kpiOptions: option.kpiOptions,
        }));
      } else {
        const config = await getFilterConfig(programId, dispatch);
        if (config?.data?.parentOptions) {
          options = config.data.parentOptions.map((option) => ({
            label: option.label,
            value: option.value,
            kpiOptions: option.kpiOptions,
          }));
        }
        dispatch(setFilterConfig(config.data));
      }

      dispatch(setFilterOptions(options));

      // Set option from URL params if available
      if (parentFilterParam && options.length > 0) {
        try {
          const parsedFilter = JSON.parse(parentFilterParam);
          const matchingOption = options.find(
            (opt) => opt.value === parsedFilter.value,
          );
          if (matchingOption) {
            dispatch(
              setSelectedKpiOption({
                label: matchingOption.label,
                value: matchingOption.value,
              }),
            );
          } else {
            dispatch(
              setSelectedKpiOption({
                label: options[0].label,
                value: options[0].value,
              }),
            );

            dispatch(setSelectedKpiTab(options[0].kpiOptions[0]));
          }
        } catch (error) {
          console.error("Error parsing parentFilter:", error);
          dispatch(
            setSelectedKpiOption({
              label: options[0].label,
              value: options[0].value,
            }),
          );
          dispatch(setSelectedKpiTab(options[0].kpiOptions[0]));
        }
      } else if (options.length > 0 && !selectedOption) {
        dispatch(
          setSelectedKpiOption({
            label: options[0].label,
            value: options[0].value,
          }),
        );
        dispatch(setSelectedKpiTab(options[0].kpiOptions[0]));
      }
    };

    fetchFilteringData();
  }, [programId, dispatch, location.search]);

  useEffect(() => {
    if (!isDropdownOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !(dropdownRef.current as any).contains(event.target)
      ) {
        setIsDropdownOpen(false); // Generated by Copilot
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownOpen]);

  const handleOpenAIOverlay = () => {
    setIsOverlayOpen(true);
  };

  const handleCloseAIOverlay = () => {
    setIsOverlayOpen(false);
  };

  return (
    <>
      <div className={styles.tabsWrapper}>
        <div className={styles.headerSection}>
          <h2 className={styles.logo}>
            {colorizeMahatriaInfinitheism(
              programTitle ? programTitle : "HDB/MSD 2025-26",
            )}
          </h2>

          {activeTab === "registrations" && (
            <div className={styles.statusSelector} ref={dropdownRef}  onClick={() => setIsDropdownOpen((prev) => !prev)}>
              <span
                className={styles.toolbar}
              >
                {colorizeMahatriaInfinitheism(
                  selectedOption?.label || "Select",
                )}{" "}
              </span>
              <span
                className={styles.dropdownArrow}
              >
                <img
                  src={isDropdownOpen ? opendropdown : closedropdown}
                  alt="dropdown"
                  style={{ pointerEvents: 'none' }}
                />
              </span>
              {isDropdownOpen && (
                <div className={styles.dropdownMenu}>
                  {filterOptions.map((option) => (
                    <div
                      key={option.value}
                      className={`${styles.dropdownItem} ${selectedOption?.value === option.value ? styles.selected : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(setSelectedKpiTab(option?.kpiOptions[0]));
                        dispatch(
                          setSelectedKpiOption({
                            label: option.label,
                            value: option.value,
                            // kpiOptions: option.kpiOptions,
                          }),
                        );
                        dispatch(setActiveTab(0));

                        dispatch(setSelectedKpiFilter(null));
                        setIsDropdownOpen(false);
                      }}
                    >
                      {colorizeMahatriaInfinitheism(option.label)}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        <div className={styles.tabs}>
          <>
            <img
              src={aiIcon}
              alt="ai icon"
              onClick={handleOpenAIOverlay}
              className={styles.aiIcon}
            />
            {tabs.map((tab) => (
              <button
                key={tab.key}
                className={clsx(styles.tab, {
                  [styles.active]: activeTab === tab.key,
                })}
                onClick={() => {
                  const filterConfig =
                    getItemInLocalStorage("filterConfig")?.data?.parentOptions;
                  if (tab.key !== "registrations") {
                    dispatch(resetProgramState());
                    setIsDropdownOpen(false);
                    // window.history.replaceState(
                    //   {},
                    //   "",
                    //   window.location.pathname,
                    // ); // Generated by Copilot
                    onTabChange?.(tab.key);
                  } else {
                    setIsDropdownOpen(false);

                    onTabChange?.(tab.key);
                  }
                  if (filterConfig.length > 0) {
                    const defaultOption = filterConfig[0];
                    dispatch(
                      setSelectedKpiOption({
                        label: defaultOption?.label,
                        value: defaultOption?.value,
                      }),
                    );
                    dispatch(setSelectedKpiTab(defaultOption.kpiOptions[0]));
                  }
                }}
              >
                {tab.icon}
                <span>{tab.label}</span>
              </button>
            ))}
          </>
        </div>
      </div>
      {/* AI Overlay Component */}
      <AIOverlay
        isOpen={isOverlayOpen}
        onClose={handleCloseAIOverlay}
        apiEndpoint={process.env.REACT_APP_AI_ASSISTANT_URL}
        programId={programId}
      />
    </>
  );
};

export default DashboardTabs;
